import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2798ffae&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2798ffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2798ffae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2798ffae')) {
      api.createRecord('2798ffae', component.options)
    } else {
      api.reload('2798ffae', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2798ffae&scoped=true&", function () {
      api.rerender('2798ffae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BoBMEha5c6wo/JS/teamMember.vue"
export default component.exports